/**
 * Centralized membership feature access helpers for Vitality FE.
 * Keys match the portal menu catalogue from the backend.
 */

export const MEMBERSHIP_FEATURE_KEYS = Object.freeze({
  ORDER_LABS: "order_labs",
  BOOK_CONSULT: "book_consult",
  LAST_SESSION: "last_session",
  COURSES: "courses",
  MEMBERSHIPS: "memberships",
  SHOP: "shop",
  COMMUNITY: "community",
  EVENTS: "events",
  SEARCH: "search",
});

/**
 * @param {object|null|undefined} user - Redux user object
 * @param {string} featureKey
 * @returns {boolean}
 */
export function hasFeature(user, featureKey) {
  const key = String(featureKey || "").trim();
  if (!key) return false;
  const features = user?.membershipFeatures;
  // Older userdata payloads omit this field — fail open until the API is deployed.
  if (!Array.isArray(features)) return true;
  return features.includes(key);
}

/**
 * Visibility follows the Admin feature matrix for both members and Free Plan.
 */
export function canShowMemberFeature(user, featureKey) {
  return hasFeature(user, featureKey);
}
